/*
=========================================================
* Material Kit 2 PRO React - v2.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// SwiperJS
import SwiperCore, { Autoplay, Navigation } from "swiper";

// SwiperJS react components
import { Swiper, SwiperSlide } from "swiper/react";

// SwiperJS styles
import "swiper/swiper.min.css";
import "swiper/css/navigation";

// Pricing page components
import SliderHeader from "pages/Produtos/Templar/Components/Header";

// Images
import bg1 from "assets/images/products/Templar.png";
import bg2 from "assets/images/products/templar-caixa.jpg";
import bg3 from "assets/images/products/templar-caixa-2.png";

function Header() {
  // install SwiperJS modules
  SwiperCore.use([Autoplay, Navigation]);
  const boobies = (  <>
    <h2>Templar</h2>
    <br />
    <br />
  </>
    );

  return (
    
    <Swiper
      autoplay={{ delay: 5000 }}
      speed={800}
      spaceBetween={0}
      slidesPerView={1}
      navigation
      loop
    >
      <SwiperSlide>
        <SliderHeader
          image={bg1}
          title={boobies}
          description="Data center com extremas capacidades de segurança cibernética para proteger indivíduos e empresas dos crescentes riscos online e offline."
          cards={[
            {
              variant: "gradient",
              color: "info",
              icon: "shuffle",
              title: "Armazenamento - Intel Blade",
              description:
                "10 lâminas SSD, embutido o Intel Kaby lake-R 4 core 8 thread i7 CPU, 2.10 GHz frequência base, GPU 300MHz (explosão até 1,15 GHz)",
            },
            {
              variant: "contained",
              color: "info",
              icon: "redeem",
              title: "Segurança",
              description:
                "FIPS 140 2, Tunnels, IPSEC (DES) 56 bit, 3DES 168 bit, MD5,SHA 1, SHA 256 de autenticação, Máscara de IP baseada em zona e Detecção de ataques.",
            },
            {
              variant: "contained",
              color: "info",
              icon: "bookmarks",
              title: "Inteligência Artificial",
              description:
                "Capacidade de utilização de diversos modelos de AI para gestão de dados e proteção de redes seguras, estabelecidas pelo Templar.",
            },
          ]}
        />
      </SwiperSlide>
      <SwiperSlide>
        <SliderHeader
          image={bg2}
          title={boobies}
          description="Centro de comunicações customizável para as suas operações de edge computing, com capacidades de processamento em ambientes urbanos e remotos."
          cards={[
            {
              variant: "contained",
              color: "grey-100",
              icon: "bookmarks",
              title: "Redes e Integrações",
              description:
                "Wi-Fi, 2G/3G/4G/5G LTE, Fibra óptica, Satélite/VSAT (Externo/Opcional).",
            },
            {
              variant: "gradient",
              color: "secondary",
              icon: "beenhere",
              title: "Mobilidade",
              description:
                "O centro de comunicações pesa 15kg, e utiliza tanto baterias USP, quanto fontes de 12V,  para manter a seu funcionamento autonomo.",
            },
            {
              variant: "contained",
              color: "grey-100",
              icon: "ballot",
              title: "Flexibilidade",
              description:
                "Capaz de executar sistemas legados e novas implementações em paralelo, buscando manter a operação de múltiplos sistemas por um só operador.",
            },
          ]}
        />
      </SwiperSlide>
      <SwiperSlide>
        <SliderHeader
          image={bg3}
          title={boobies}
          description="Central de controle para armazenamento e proteção de suas atividades em casos de emergências, internas e externas."
          cards={[
            {
              variant: "contained",
              color: "error",
              icon: "tune",
              title: "Redes de emergência",
              description:
                "A função dual SIM usa 2x antenas de alto ganho para estabelecer uma rede e integrar até 7200 dispositivos, em paralelo.",
            },
            {
              variant: "contained",
              color: "error",
              icon: "settings_suggest",
              title: "Total isolamento",
              description:
                "As Blades Intel podem ser desligadas e removidas em menos de 30 segundos, em total segurança, além de poderem ser isoladas da rede atacada.",
            },
            {
              variant: "gradient",
              color: "error",
              icon: "compare",
              title: "Sistema agnóstico",
              description:
                "Sistema pode ser adaptado de acordo com a necessidade de uso, desde emergências naturais à ambientes internos hostis e de risco de espionagem industrial.",
            },
          ]}
        />
      </SwiperSlide>
    </Swiper>
  );
}

export default Header;
